import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "whole-update-page" }
const _hoisted_2 = { class: "update-box" }
const _hoisted_3 = { style: {"display":"flex","flex-direction":"column","gap":"8px"} }
const _hoisted_4 = { class: "button-wrapper" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _cache[3] || (_cache[3] = _createElementVNode("b", null, "Apply country code", -1)),
        _createElementVNode("p", null, "You've selected " + _toDisplayString(_ctx.currentCode) + " as a country code. Would you like to apply it to all reservations?", 1)
      ]),
      _createElementVNode("div", _hoisted_4, [
        _createElementVNode("button", {
          class: "button",
          onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.returnToParent()))
        }, "This one only"),
        _createElementVNode("button", {
          class: "update-button",
          onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.clickUpdate()))
        }, "Apply to all")
      ])
    ]),
    _createElementVNode("div", {
      class: "overLay",
      onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.returnToParent()))
    })
  ]))
}